function GoogleIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.8055 10.0415H21V10H12V14H17.6515C16.827 16.3285 14.6115 18 12 18C8.6865 18 6 15.3135 6 12C6 8.6865 8.6865 6 12 6C13.5295 6 14.921 6.577 15.9805 7.5195L18.809 4.691C17.023 3.0265 14.634 2 12 2C6.4775 2 2 6.4775 2 12C2 17.5225 6.4775 22 12 22C17.5225 22 22 17.5225 22 12C22 11.3295 21.931 10.675 21.8055 10.0415Z"
        fill="#FFC107"
      />
      <path
        d="M3.153 7.3455L6.4385 9.755C7.3275 7.554 9.4805 6 12 6C13.5295 6 14.921 6.577 15.9805 7.5195L18.809 4.691C17.023 3.0265 14.634 2 12 2C8.159 2 4.828 4.1685 3.153 7.3455Z"
        fill="#FF3D00"
      />
      <path
        d="M12 22C14.583 22 16.93 21.0115 18.7045 19.404L15.6095 16.785C14.5718 17.5742 13.3037 18.001 12 18C9.399 18 7.1905 16.3415 6.3585 14.027L3.0975 16.5395C4.7525 19.778 8.1135 22 12 22Z"
        fill="#4CAF50"
      />
      <path
        d="M21.8055 10.0415H21V10H12V14H17.6515C17.2571 15.1082 16.5467 16.0766 15.608 16.7855L15.6095 16.7845L18.7045 19.4035C18.4855 19.6025 22 17 22 12C22 11.3295 21.931 10.675 21.8055 10.0415Z"
        fill="#1976D2"
      />
    </svg>
  )
}

function FacebookIcon() {
  return (
    <svg
      width="19"
      height="20"
      viewBox="0 0 19 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1413_24421)">
        <path
          d="M14.2492 0.503953L11.7854 0.5C9.01731 0.5 7.22848 2.3353 7.22848 5.17593V7.33184H4.75119C4.53712 7.33184 4.36377 7.50539 4.36377 7.71946V10.8431C4.36377 11.0572 4.53732 11.2306 4.75119 11.2306H7.22848V19.1126C7.22848 19.3267 7.40182 19.5 7.61589 19.5H10.8481C11.0621 19.5 11.2355 19.3265 11.2355 19.1126V11.2306H14.132C14.3461 11.2306 14.5194 11.0572 14.5194 10.8431L14.5206 7.71946C14.5206 7.61667 14.4797 7.51824 14.4071 7.4455C14.3346 7.37276 14.2358 7.33184 14.133 7.33184H11.2355V5.50424C11.2355 4.62583 11.4448 4.1799 12.5891 4.1799L14.2488 4.17931C14.4627 4.17931 14.636 4.00576 14.636 3.79189V0.891374C14.636 0.677699 14.4629 0.504349 14.2492 0.503953Z"
          fill="#4E4E4E"
        />
      </g>
      <defs>
        <clipPath id="clip0_1413_24421">
          <rect
            width="19"
            height="19"
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}

function TwitterIcon() {
  return (
    <svg
      width="20"
      height="18"
      viewBox="0 0 20 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20 2.79875C19.2563 3.125 18.4637 3.34125 17.6375 3.44625C18.4875 2.93875 19.1363 2.14125 19.4412 1.18C18.6488 1.6525 17.7738 1.98625 16.8412 2.1725C16.0887 1.37125 15.0162 0.875 13.8462 0.875C11.5763 0.875 9.74875 2.7175 9.74875 4.97625C9.74875 5.30125 9.77625 5.61375 9.84375 5.91125C6.435 5.745 3.41875 4.11125 1.3925 1.6225C1.03875 2.23625 0.83125 2.93875 0.83125 3.695C0.83125 5.115 1.5625 6.37375 2.6525 7.1025C1.99375 7.09 1.3475 6.89875 0.8 6.5975C0.8 6.61 0.8 6.62625 0.8 6.6425C0.8 8.635 2.22125 10.29 4.085 10.6712C3.75125 10.7625 3.3875 10.8062 3.01 10.8062C2.7475 10.8062 2.4825 10.7913 2.23375 10.7362C2.765 12.36 4.2725 13.5538 6.065 13.5925C4.67 14.6838 2.89875 15.3412 0.98125 15.3412C0.645 15.3412 0.3225 15.3263 0 15.285C1.81625 16.4563 3.96875 17.125 6.29 17.125C13.835 17.125 17.96 10.875 17.96 5.4575C17.96 5.27625 17.9538 5.10125 17.945 4.9275C18.7588 4.35 19.4425 3.62875 20 2.79875Z"
        fill="#4E4E4E"
      />
    </svg>
  )
}

function InstagramIcon({ ...props }) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={props?.onClick}
      style={{ cursor: 'pointer' }}
    >
      <g clipPath="url(#clip0_1413_24426)">
        <path
          d="M14.5862 0H5.41381C2.42858 0 0 2.42858 0 5.41381V14.5863C0 17.5714 2.42858 20 5.41381 20H14.5863C17.5714 20 20 17.5714 20 14.5863V5.41381C20 2.42858 17.5714 0 14.5862 0V0ZM18.8275 14.5863C18.8275 16.9249 16.9249 18.8275 14.5862 18.8275H5.41381C3.0751 18.8275 1.17248 16.9249 1.17248 14.5863V5.41381C1.17248 3.0751 3.0751 1.17248 5.41381 1.17248H14.5863C16.9249 1.17248 18.8275 3.0751 18.8275 5.41381V14.5863Z"
          fill="#4E4E4E"
        />
        <path
          d="M9.99984 4.53125C6.9844 4.53125 4.53125 6.9844 4.53125 9.99984C4.53125 13.0153 6.9844 15.4684 9.99984 15.4684C13.0153 15.4684 15.4684 13.0153 15.4684 9.99984C15.4684 6.9844 13.0153 4.53125 9.99984 4.53125ZM9.99984 14.2959C7.63107 14.2959 5.70373 12.3688 5.70373 9.99984C5.70373 7.63107 7.63107 5.70373 9.99984 5.70373C12.3688 5.70373 14.2959 7.63107 14.2959 9.99984C14.2959 12.3688 12.3688 14.2959 9.99984 14.2959Z"
          fill="#4E4E4E"
        />
        <path
          d="M15.5993 2.58887C14.7082 2.58887 13.9834 3.31381 13.9834 4.20477C13.9834 5.09588 14.7082 5.82083 15.5993 5.82083C16.4904 5.82083 17.2154 5.09588 17.2154 4.20477C17.2154 3.31366 16.4904 2.58887 15.5993 2.58887ZM15.5993 4.64819C15.3549 4.64819 15.1559 4.44922 15.1559 4.20477C15.1559 3.96017 15.3549 3.76135 15.5993 3.76135C15.8439 3.76135 16.0429 3.96017 16.0429 4.20477C16.0429 4.44922 15.8439 4.64819 15.5993 4.64819Z"
          fill="#4E4E4E"
        />
      </g>
      <defs>
        <clipPath id="clip0_1413_24426">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

function LinkedInIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1413_24430)">
        <path
          d="M19.9951 19.9999V19.999H20.0001V12.664C20.0001 9.07569 19.2276 6.31152 15.0326 6.31152C13.0159 6.31152 11.6626 7.41819 11.1101 8.46736H11.0517V6.64652H7.07422V19.999H11.2159V13.3874C11.2159 11.6465 11.5459 9.96319 13.7017 9.96319C15.8259 9.96319 15.8576 11.9499 15.8576 13.499V19.9999H19.9951Z"
          fill="#4E4E4E"
        />
        <path
          d="M0.330078 6.64746H4.47675V20H0.330078V6.64746Z"
          fill="#4E4E4E"
        />
        <path
          d="M2.40167 0C1.07583 0 0 1.07583 0 2.40167C0 3.7275 1.07583 4.82583 2.40167 4.82583C3.7275 4.82583 4.80333 3.7275 4.80333 2.40167C4.8025 1.07583 3.72667 0 2.40167 0V0Z"
          fill="#4E4E4E"
        />
      </g>
      <defs>
        <clipPath id="clip0_1413_24430">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

function DocumentIcon() {
  return (
    <svg
      width="50"
      height="50"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="2" y="2" width="32" height="32" rx="16" fill="#FFCDD1" />
      <rect
        x="2"
        y="2"
        width="32"
        height="32"
        rx="16"
        stroke="#EEFFF4"
        stroke-width="4"
      />
      <path
        d="M19.3337 11.5131V14.2668C19.3337 14.6402 19.3337 14.8269 19.4063 14.9695C19.4702 15.0949 19.5722 15.1969 19.6977 15.2608C19.8403 15.3335 20.027 15.3335 20.4003 15.3335H23.154M23.3337 16.659V21.4668C23.3337 22.5869 23.3337 23.147 23.1157 23.5748C22.9239 23.9511 22.618 24.2571 22.2416 24.4488C21.8138 24.6668 21.2538 24.6668 20.1337 24.6668H15.867C14.7469 24.6668 14.1868 24.6668 13.759 24.4488C13.3827 24.2571 13.0767 23.9511 12.885 23.5748C12.667 23.147 12.667 22.5869 12.667 21.4668V14.5335C12.667 13.4134 12.667 12.8533 12.885 12.4255C13.0767 12.0492 13.3827 11.7432 13.759 11.5515C14.1868 11.3335 14.7469 11.3335 15.867 11.3335H18.0082C18.4974 11.3335 18.7419 11.3335 18.9721 11.3888C19.1762 11.4377 19.3713 11.5186 19.5502 11.6282C19.7521 11.7519 19.925 11.9249 20.2709 12.2708L22.3964 14.3962C22.7423 14.7421 22.9153 14.9151 23.0389 15.1169C23.1486 15.2959 23.2294 15.491 23.2784 15.695C23.3337 15.9252 23.3337 16.1698 23.3337 16.659Z"
        stroke="#D91F2E"
        stroke-width="1.33333"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  )
}

function HomeIcon({ color = '#000', ...props }: React.ComponentProps<'svg'>) {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.6667 18.1668H17.3333M13.1814 6.30345L7.52949 10.6994C7.15168 10.9932 6.96278 11.1402 6.82669 11.3242C6.70614 11.4872 6.61633 11.6708 6.56169 11.866C6.5 12.0864 6.5 12.3257 6.5 12.8043V18.8334C6.5 19.7669 6.5 20.2336 6.68166 20.5901C6.84144 20.9037 7.09641 21.1587 7.41002 21.3185C7.76654 21.5001 8.23325 21.5001 9.16667 21.5001H18.8333C19.7668 21.5001 20.2335 21.5001 20.59 21.3185C20.9036 21.1587 21.1586 20.9037 21.3183 20.5901C21.5 20.2336 21.5 19.7669 21.5 18.8334V12.8043C21.5 12.3257 21.5 12.0864 21.4383 11.866C21.3837 11.6708 21.2939 11.4872 21.1733 11.3242C21.0372 11.1402 20.8483 10.9932 20.4705 10.6994L14.8186 6.30345C14.5258 6.07574 14.3794 5.96189 14.2178 5.91812C14.0752 5.87951 13.9248 5.87951 13.7822 5.91812C13.6206 5.96189 13.4742 6.07574 13.1814 6.30345Z"
        stroke="#667085"
        stroke-width="1.66667"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  )
}

function TiktokIcon({ ...props }) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={props?.onClick}
      style={{ cursor: 'pointer' }}
    >
      <path
        d="M16.5999 5.82C15.9165 5.03953 15.5398 4.0374 15.5399 3H12.4499V15.4C12.4266 16.0712 12.1434 16.7071 11.6602 17.1735C11.177 17.6399 10.5315 17.9004 9.85991 17.9C8.43991 17.9 7.25991 16.74 7.25991 15.3C7.25991 13.58 8.91991 12.29 10.6299 12.82V9.66C7.17991 9.2 4.15991 11.88 4.15991 15.3C4.15991 18.63 6.91991 21 9.84991 21C12.9899 21 15.5399 18.45 15.5399 15.3V9.01C16.7929 9.90985 18.2973 10.3926 19.8399 10.39V7.3C19.8399 7.3 17.9599 7.39 16.5999 5.82Z"
        fill="#4E4E4E"
      />
    </svg>
  )
}

export {
  GoogleIcon,
  FacebookIcon,
  TwitterIcon,
  LinkedInIcon,
  InstagramIcon,
  DocumentIcon,
  HomeIcon,
  TiktokIcon,
}
